export const API_PER_FIX = '/api'
export const API_PER_VERSION = '/v2'
export const DOMAIN='https://goraicommunity.com'
// export const DOMAIN = 'http://localhost:8889'
export const API_BASE = DOMAIN + API_PER_FIX + API_PER_VERSION
export const END_POINT_UPLOAD = API_BASE + '/upload'
export const END_POINT_MEMBERS = API_BASE + '/member'
export const END_POINT_ACTIVITY = API_BASE + '/activity'
export const END_POINT_LOGIN = API_BASE + '/auth/login'
export const END_POINT_SIGNUP = API_BASE + '/auth/register'
export const END_POINT_RESET_PASSWORD = API_BASE + '/auth/reset-password'
export const END_POINT_CONFIG = API_BASE + '/config'
export const END_POINT_ADMIN_ADD_USER = API_BASE + '/admin/add-user'
